import axios from '@/config/axios';
import {TARGET_PARAMS} from '@/config/env';

/*
 * home + people
 * */
//获取首页轮播广告(大屏幕)
export const getIndexSliderService = () => axios("/centre/wealth/advert/search.act?seat=web_home&state=1&rb=href,back,name,note");

//获取首页轮播广告(小屏幕)
export const getIndexPhoneSliderService = () => axios("/centre/wealth/advert/search.act?seat=wap_home&state=1&rb=href,back,name,note");

//获取城市
export const getPlaceService = () => axios("/centre/graphs/people/select.act?rb=gb_hy,place,place_sub&ab=.enum&type=");

//获取人才类型列表
export const getTalentTyleService = () => axios("/centre/graphs/people/nature/search.act?stat=1&ob=-boost,-mtime");

//获取人才列表
export const getTalentService = (options={}) => {
  let def = {
    type:'',wd:'',place:'',place_sub:'',gb_hy_all:'',pn:1,rn:10
  }

  let result = {...def,...options};
  return axios(
    `/centre/graphs/people/search.act?ab=.form,_fork,_text&rb=id,name,head,rank,organ,title,tags,capacity,type,type_text,note,sex,uid,boost&ob=-,-weigh,-mtime`+
    `&type=${result.type}&pn=${result.pn}&rn=${result.rn}&wd=${result.wd}&place=${result.place}&place_sub=${result.place_sub}`+
    `&gb_hy_all=${result.gb_hy_all}&rank=1`
  );
}

//获取人才列表(autocomplete)
export const getTalentAdviseService = (options={}) => {
  let def = {
    wd:'',pn:1,rn:10
  }

  let result = {...def,...options};
  return axios(
    `/centre/graphs/people/advise.act?ab=.form,_fork&rb=id,name,title&ob=-,-weigh,-mtime`+
    `&pn=${result.pn}&rn=${result.rn}&wd=${result.wd}&rank=1`
  );
}

//获取热门需求
export const getHotTargetService = (place,place_sub) =>
  axios(
    `/centre/graphs/target/search.act?type=&ab=_fork,_text&ob=-boost_home,-boost,time&open_id=&place=${place=''}&place_sub=${place_sub=''}`+
    `&pn=1&rn=6&rb=id,stat,stat_text,dtime,stock,gift,type,type_text,view,owner,mtime,countdown,name,note,ctime`
    ,TARGET_PARAMS);

//获取领域
export const getTradeService = () => axios("/centre/graphs/people/select.act?rb=trade,trade_sub&ab=.enum&type=");

//获取用户信息(可以用来判断是否登录)
export const getUserInfoService = () => axios("/centre/mine/info.jsp?ab=wx_img&rb=*");

//获取用户信息,用户认证和浏览信息
export const getRankAndViewService = () => axios("/common/more.act",{
  "userInfo":{
    "at":"centre/mine/info.jsp?ab=wx_img&rb=*"
  },
  "view":{
    "at":"centre/graphs/mine/acount"
  },
  "vip":{
    "at":"centre/data/vip/auth"
  }
});

//获取用户档案信息
export const getUserResumeService = (id="-") => axios(`/centre/graphs/people/search.act?rn=0&ab=.enum,.form,_fork,_text,wx_img&id=${id}`);

//上传图片(单图片上传)
export const sendFileService = (formDate) => axios("/centre/file/create.act",formDate);

//提交用户档案信息
export const sendUserResumeService = (data) => axios("/centre/graphs/people/update.act?id=-&ab=patch",data);

//删除用户档案信息
export const delUserResumeService = (data) => axios("/centre/graphs/people/update.act",data);

//获取合作案例类型
export const getSampleTypeService = (options={}) => {
  return axios(
    `/centre/wealth/sample/select.act?ab=.enum`
  );
};

//获取合作案例列表
export const getSampleListService = (pn,rn) => {
//type.ne=&type.is=well 表示 type 不为空串且有值
  return axios(
    `/centre/wealth/sample/search.act?type.ne=&type.is=well&ab=_fork,_text&pn=${pn}&rn=${rn}&state=1&rb=name,id,body,note,logo,mtime`
  );
};

//获取合作案例详情
export const getSampleDetailService = (id) => {
  return axios(
    `/centre/wealth/sample/search.act?id=${id}&ab=_text,_link`
  );
};

//获取地市和行业
export const getMapPlaceAndTradeService = (group='') => {
  return axios(
    `/centre/data/native/search.act?rn=0&state=1&ob=-boost,-ctime&group=${group}`
  );
};

//获取人才地图人才列表
export const getMapTalentService = (options={}) => {
  let def = {
    wd:'',place:[],place_sub:[],gb_hy_all:[],pn:1,rn:10
  }

  let result = {...def,...options};
  return axios(
    `/centre/graphs/people/search.act?ab=.form,_fork,_text&rb=id,name,head,rank,organ,title,tags,capacity,type,type_text,note,gb_hy,place,place_sub,uid,boost&ob=-,-weigh,-mtime&rank=1`
    ,result);
}

//获取人才地图机构列表
export const getMapLocalService = (options={}) => {
  let def = {
    wd:'',place:[],place_sub:[],gb_hy_all:[],pn:1,rn:10
  }

  let result = {...def,...options};
  return axios(
    `/centre/graphs/locale/search.act?ab=.form,_fork,_text&rb=id,name,icon,rank,note,place,place_sub,kind&ob=-,-weigh,-mtime&rank=1`
    ,result);
};

//人才聚集度排行榜
export const getMapTalentCountService = (options={}) => {
  let def = {
    wd:'',place:[],place_sub:[],gb_hy_all:[],priv:{"ni":[1,2]}
  }
  let req = {...def, ...options};

  if (!req.place || !req.place.length) {
    req.place = {ni: ['0', '*', '']}
  }

  let url = `/centre/graphs/people/acount.act?ab=.form,_fork,_text&rb=place&rank=1&rn=0`;
  return axios(url,req);
}

//人才聚集度排行榜(市)
export const getMapTalentCityCountService = (options={}) => {
  let def = {
    wd:'',place:"",gb_hy_all:[],priv:{"ni":[1,2]}
  }
  let req = {...def,...options};
  let url = `/centre/graphs/people/acount.act?ab=.form,_fork,_text&rb=place_sub&rank=1&rn=0&place.ni.=0&place.ni.=*&place.ni.=`;
  return axios(url,req);
}

//产业创新聚集度排行榜
export const getMapLocalCountService = (options={}) => {
  let def = { kind:'all',wd:'',place:[],place_sub:[],gb_hy_all:[]};
  let req = {...def,...options};

  let url = `/centre/graphs/locale/acount.act?ab=.form,_fork,_text&rb=place&rank=1&rn=0`;

  if(req.kind == "education"){
    req.kind = ["Edu","Res"];
  }else if(req.kind == "company"){
    req.kind = ["Com","Ins","Org"];
  }else{
    delete req.kind;
  }

  if (!req.place || !req.place.length) {
    req.place = {ni: ['0', '*', '']}
  }

  /*let req = {
   ar:[
   {place: {'ni': ['0', '*', '']}},
   {priv:{"ni":[1,2]}},
   {wd:result.wd,place:result.place,place_sub:result.place_sub,gb_hy_all:result.gb_hy_all}
   ]
   };*/

  /*if(result.kind == "education"){
   req.ar.push({kind:["Edu","Res"]})
   }else if(result.kind == "company"){
   req.ar.push({kind:["Com","Ins","Org"]})
   }*/

  return axios(url,req);
}

//产业创新聚集度排行榜(市)
export const getMapLocalCityCountService = (options={}) => {
  let def = { kind:'all',wd:'',place:"",gb_hy_all:[],priv:{"ni":[1,2]}};
  let result = {...def,...options};

  let url = `/centre/graphs/locale/acount.act?ab=.form,_fork,_text&rb=place_sub&rank=1&rn=0&place.ni.=0&place.ni.=*&place.ni.=`;
  let data = {
    wd:result.wd,
    place:result.place,
    gb_hy_all:result.gb_hy_all,
    priv:result.priv
  };

  if(result.kind == "education"){
    data.kind=["Edu","Res"];
  }else if(result.kind == "company"){
    data.kind=["Com","Ins","Org"];
  }

  return axios(url,data);
}

//获取登录短信验证码
export const getMesCode = ( options={} )=>{
  let def = { phone:'',captcode:'' };
  let result = {...def,...options};
  return axios(
    `/centre/oauth2/sms/create.act?phone=${result.phone}&captcode=${result.captcode}`,
  )
};

//登录\注册账号
export const userLogin = (formdata) =>{
  return axios(
    `/centre/oauth2/sess/create.act`,
    formdata
  )
};

//获取微信登录参数
export const getWXLoginParams = () =>{
  return axios(
    `/common/conf/oauth2.json`
  )
};

//退出登录
export const userSign = () =>{
  return axios(
    `/centre/sign/delete.act`
  )
};

//获取人才档案二维码（applet/detail，邮件打开页面）
export const getAppletQrcodeService = (id="-") => axios(`/centre/graphs/people/search.act?rn=0&ab=wx_con&rb=id,wx_con&id=${id}`);

//获取用机构信息
export const getLocalDetailService = (id="") => axios(`/centre/graphs/locale/search.act?rn=0&ab=_text,_fork,.form&id=${id}`);

//获取机构类型
export const getLocalTyleService = () => axios("/centre/graphs/locale/search.act?ab=.enum");

//获取机构列表(autocomplete)
export const getLocalAdviseService = (options={}) => {
  let def = {
    wd:'',pn:1,rn:10
  }

  let result = {...def,...options};
  return axios(
    `/centre/graphs/locale/advise.act?ab=.form,_fork&rb=id,name,title&ob=-,-boost,-mtime`+
    `&pn=${result.pn}&rn=${result.rn}&wd=${result.wd}&rank=1`
  );
};

/*
 * 聊天页面所需的全部接口
 * */
export const getChatAction = (aid) => {
  return axios(
    `/centre/graphs/target/action/search.act?id=${aid}`
  )
};
export const getChatTarget = (tid) => {
  return axios(
    `/centre/graphs/target/search.act?id=${tid}&ab=_fork&rb=owner,gift,stock,split,name,note,dtime,value,price,stat`
  )
};
export const getChatList = (mid,pid,tid,aid) => {
  return axios(
    `/centre/tattle/chat/search.act?ab=more,has_tel&ob=-ctime&mate_id=${mid}&people_id=${pid}&target_id=${tid}&action_id=${aid}`
  )
};
export const getChatActionType = (tid,source) => {
  return axios(
    `/centre/graphs/target/action/create.act?target=${tid}&source=${source}`
  )
};
export const getChatAccept = (aid) => {
  return axios(
    `/centre/graphs/target/action/search.act?id=${aid}&ab=prev`
  )
};
export const getChatAcceptEnsure = (aid) => {
  return axios(
    `/centre/graphs/target/action/update.act?id=${aid}&stat=1&type=1`
  )
};
export const setChatActionType = (tid) => {
  return axios(
    `/centre/graphs/target/action/create.act?type=1&target=${tid}`
  )
};
export const getPeopleDetail = (pid) => {
  return axios(
    `/centre/graphs/people/advise.act?id=${pid}&ab=_text&rb=name,title,organ,head,rank,type,uid,boost`
  )
};
//获取需求聊天列表
export const getPeopleChatList = (pn,rn,type) => {
  //target_id=*  取所有聊天    target_id=~   取所有需求聊天
  if(type){
    return axios(
      `/centre/tattle/mate/search.act?pn=${pn}&rn=${rn}&target_id=${type}`
    )
  }else{
    return axios(
      `/centre/tattle/mate/search.act?pn=${pn}&rn=${rn}`
    )
  }

};
//绑定手机号发送短信验证码
export const sendSmsCode = (phone,captcode) => {
  return axios(
    `/centre/mine/sms-set-phone.jsp?act=send&phone=${phone}&captcode=${captcode}`
  )
};
//绑定手机号
export const sendBindphone = (phone,code) => {
  return axios(
    `/centre/mine/sms-set-phone.jsp?act=save&phone=${phone}&capt_sms=${code}`
  )
};

//合作申请
export const sendTeamworkMsgService = (data) => axios("/centre/data/vip/create.act",data);

//获取权限
export const getAuthorService = (data) => axios(`/centre/data/vip/auth.act`,data);

//权限状态
export const getAuthorStatusService = (id="-") => axios(`/centre/data/vip/search.act?ab=_text,_fork,.form&id=${id}`);

/*
 * target
 * */

//第一次进入需求大厅
export const firstGetTargetService = ( options={} ) => {
  let def = { type:[],place:'',place_sub:'',wd:'',pn:1,rn:10 };
  let result = {...def,...options};

  let mainParams = {
    "ob":"-,open,time,-boost,-ctime",
    "ab":"_fork,_text,wx_img",
    "rb":'id,stat,dtime,stock,split,gift,type,view,owner,mtime,name,note,ctime,allot,place,place_sub,gb_hy',
    "place":result.place,
    "place_sub":result.place_sub,
    "type":result.type,
    "wd":result.wd,
    "pn":result.pn,
    "rn":result.rn
  };
  Object.assign(mainParams,TARGET_PARAMS);

  let allotParams = {
    "ob":"-allot",
    "ab":"_fork,_text",
    "allot": {"ne": 0},
    "pn":1,
    "rn":3
  };
  Object.assign(allotParams,TARGET_PARAMS);

  let giftParams = {
    "ob":"-total",
    "ab":"_fork,_text",
    "pn":1,
    "rn":3
  };
  Object.assign(giftParams,TARGET_PARAMS);

  let hotParams = {
    "ob":"-boost",
    "ab":"_fork,_text",
    "pn":1,
    "rn":3
  };
  Object.assign(hotParams,TARGET_PARAMS);

  return axios("/common/more.act",{
    "mainTarget":{
      "at":"/centre/graphs/target/search",
      "in":mainParams
    },
    "allotTarget":{
      "at":"/centre/graphs/target/search",
      "in":allotParams
    },
    "giftTarget":{
      "at":"/centre/graphs/target/search",
      "in":giftParams
    },
    "hotTarget":{
      "at":"/centre/graphs/target/search",
      "in":hotParams
    },
    "notAcount":{
      "at":"/centre/graphs/target/acount",
      "in":{
        "stat": {"in": [3]}
      }
    },
    "acount":{
      "at":"/centre/graphs/target/acount",
      "in":{
        "stat": {"in": [4,5]}
      }
    }
  });
};

//获取需求大厅活动列表
export const getTargetService = (options={}) => {
  let def = { type:[],wd:'',place:'',place_sub:'',pn:1,rn:10 };
  let result = {...def,...options};

  let url = `/centre/graphs/target/search.act?ab=_fork,_text&ob=-,open,time,-boost,-ctime&pn=${result.pn}&rn=${result.rn}&rb=id,stat,dtime,stock,split,gift,type,view,owner,mtime,name,note,ctime,allot,place,place_sub,gb_hy`;
  let data = {
    wd:result.wd,
    place:result.place,
    place_sub:result.place_sub,
    type:result.type
  };
  Object.assign(data,TARGET_PARAMS);

  return axios(url,data);

};

//获取热门需求
export const getHotTarget = (options={}) => {
  let def = { npn:2,nrn:5 };
  let result = {...def,...options};

  return axios(`/centre/graphs/target/search.act?ab=_fork,_text&ob=-boost&pn=${result.npn}&rn=${result.nrn}&rb=id,stat,dtime,stock,split,gift,type,view,owner,mtime,name,note,ctime,allot,place,place_sub,gb_hy`,TARGET_PARAMS);

};

//第一次进入需求详情
export const firstGetTargetDetail = ( id,tab ) => {
  let DetailParams = {
    id:id,
    tab:tab,
    ab:"_link,_fork,_enum,_text,wx_img,same",
  };

  let allotParams = {
    ob:"-allot",
    ab:"_fork,_text",
    allot: {".ne": 0},
    pn:1,
    rn:3
  };
  Object.assign(allotParams,TARGET_PARAMS);

  let giftParams = {
    ob:"-total",
    ab:"_fork,_text",
    pn:1,
    rn:3
  };
  Object.assign(giftParams,TARGET_PARAMS);

  return axios("/common/more.act",{
    "TargetDetail": {
      "at":"/centre/graphs/target/search",
      "in":DetailParams
    },
    "allotTarget":{
      "at":"/centre/graphs/target/search",
      "in":allotParams
    },
    "giftTarget":{
      "at":"/centre/graphs/target/search",
      "in":giftParams
    }
  });
};

//获取需求详情
export const getDetailService = (id,tab) => {
  return axios(
    `/centre/graphs/target/search.act?tab=${tab}&id=${id}&ab=_link,_fork,_enum,_text,wx_img`
  );
};
//获取需求详情贡献榜列表（部分数据）
export const getAcceptTargetList = (target) => {
  return axios(
    `/centre/graphs/target/action/search.act?target=${target}&ab=chat&stat=1&pn=1&rn=100&ab=origin,_text,_fork&rb= id,actor`
  )
};
//获取需求详情尝试解决的专家列表
export const getNotAcceptTargetList = (target) => {
  return axios(
    `/centre/graphs/target/action/search.act?target=${target}&ab=chat&stat=0&type=1&pn=1&rn=999&ab=origin,_text,_fork&rb= id,actor`
  )
};

//获取贡献榜详情
export const getContributeService = (options={}) => {
  let def = { id:'',type:'',pn:1,rn:10 };
  let result = {...def,...options};
  return axios(
    `/centre/graphs/target/action/search.act?target=${result.id}&ab=${result.type}&pn=${result.pn}&rn=${result.rn}`
  );
};

//获取人才列表
export const getTaregtTalentService = (options={}) => {
  let def = { type:'',pn:1,rn:16 };
  let result = {...def,...options};
  var temp='';
  options.type.split(",").map((item)=>{
    temp = temp + '&gb_hy_all[]=' + item
  });
  return axios(
    `/centre/graphs/people/search.act?ab=.form,_fork,_text&rb=id,name,head,rank,organ,title,note,sex,uid,boost&ob=-,-boost,-mtime&${temp}&pn=${result.pn}&rn=${result.rn}&rank=1`
  );
};

//获取创建活动时城市和需求类型
export const getPlaceandTargetService = () => {
  return axios(
    `/centre/graphs/target/select.act?ab=.enum`
  )
};

//编辑活动时获取活动详情
export const getTargetUpdateDetail = (id) => {
  return axios(
    `/centre/graphs/target/search.act?tab=create&id=${id}&ab=_link,_fork,_enum,_text&rb=id,name,body,logo,place,place_sub,type,split,stock,gift,allot,linkman,linktel,dtime,days,bill,stat,deny_stat,gb_hy`
  )
};

//获取创建活动时礼物信息
export const getCreateGift = (options={}) => {
  return axios(
    `/centre/wealth/gift/search.act?ob=-boost&ab=_link&price.ge=1&type.in.=1&type.in.=2&type.in.=3&rb=id,name,note,price,value,logo,type`
  )
  //gt:大于   ge:大于或等于
  // return axios(
  //   `/centre/wealth/gift/search.act?ob=-boost&ab=_link&price:ge=1&type.in.=1&type.in.=2&type.in.=3&rb=id,name,note,price,value,logo,type`
  // )
};

//获取当前用户积分情况
export const getUserStore = () => {
  return axios(
    `/centre/wealth/wallet/search.act`
  )
};

//提交创建活动数据
export const createTarget = (url,formdata) =>{
  return axios(url, formdata)
};

//提交更新活动数据
export const updateTarget = (id,formdata) => {
  return axios(
    `/centre/graphs/target/update.act?id=${id}`,
    formdata
  )
};

//获取支付二维码字串
export const getTargetApplyQRcode = (bid) => {
  return axios(
    `/centre/wealth/pay/weixin/qrcode.act?bill_id=${bid}`
  )
};

//发送采纳通知
export const sendChatAcceptMsg = (tid,aid,rate) => {
  return axios(
    `/centre/tattle/note.jsp?type=accept&target_id=${tid}&action_id=${aid}&rate=${rate}`
  )
};

//获取需求聊天列表（行为列表）
export const getTargetChatList = (target,stat,pn,rn) => {
  return axios(
    `/centre/graphs/target/action/search.act?target=${target}&ab=chat&stat=${stat}&pn=${pn}&rn=${rn}`
  )
};

//获取专题列表
export const getHomeColumnList = (data) => {
  return axios(
    `/centre/data/column/search.act?ob=-boost&state=1&rb=id,name,note,home_img,list_img,link`,data
  )
};

//获取专题详情
export const getHomeColumnDetailService = (id="") => axios(
  `/centre/data/column/search.act?ab=_text,_fork,.form,wx_img&rb=body,name,note,id,info_img&id=${id}`
);

//获取专题相关人才
export const getHomeColumnTalentService = (options={}) => {
  let def = {
    id:'',pn:1,rn:12
  }

  let rsq = {...def,...options};
  return axios(
    `/centre/data/column/people/search.act?column_id=${rsq.id}&pn=${rsq.pn}&rn=${rsq.rn}&ab=.form,_fork,_text`+
    `&rb=id,name,head,rank,organ_id,title,tags,capacity,type,type_text,note,sex,uid,boost&ob=-,-weigh,-mtime`
  )
};

//获取专题相关机构
export const getHomeColumnLocalService = (options={}) => {
  let def = {
    id:'',pn:1,rn:10
  }

  let rsq = {...def,...options};
  return axios(
    `/centre/data/column/locale/search.act?column_id=${rsq.id}&pn=${rsq.pn}&rn=${rsq.rn}&ab=.form,_fork,_text&`+
    `rb=id,name,icon,rank,note,kind&ob=-,-weigh,-mtime&rank=1`
  )
};

//获取专题相关需求
export const getHomeColumnTargetService = (options={}) => {
  let def = {
    id:'',pn:1,rn:4
  }

  let rsq = {...def,...options};
  return axios(
    `/centre/data/column/target/search.act?column_id=${rsq.id}&pn=${rsq.pn}&rn=${rsq.rn}`+
    `&ab=.form,_fork,_text&ob=-,open,time,-boost,-ctime`+
    `&rb=id,stat,stat_text,dtime,stock,gift,type,type_text,view,owner,mtime,countdown,name,note,ctime`,
    TARGET_PARAMS
  )
};

//获取我的需求列表
export const getMineTargetList = (options={}) => {
  let def = {
    type:'create',pn:1,rn:10
  };
  let res = {...def,...options};
  return axios(
    `centre/graphs/target/search.act?tab=${res.type}&ab=_fork,_text&ob=-mtime&pn=${res.pn}&rn=${res.rn}&rb=id,bill,deny_stat,deny_memo,stat,stat_text,dtime,stock,gift,type,type_text,view,owner,mtime,ctime,name,note`,
    TARGET_PARAMS
  )
};

//删除需求
export const deleteTarget = (id) => {
  return axios(
    `centre/graphs/target/delete.act?id=${id}`
  )
};

//更新需求列表单个项目
export const updateTargetListItem = (options={}) => {
  let def = {id:'',pn:1,rn:10};
  let res = {...def,...options};
  return axios(
    `centre/graphs/target/search.act?tab=create&id.=${res.id}&ab=_fork,_text&ob=-mtime&pn=${res.pn}&rn=${res.rn}&rb=id,bill,deny_stat,deny_memo,stat,stat_text,dtime,stock,gift,type,type_text,view,owner,mtime,ctime,name,note`
  )
};
//获取cookie
export const getCookieParams = () => {
  return axios(
    `/centre/tattle/chat/search.act?ab=more,has_tel&ob=-ctime&mate_id=x&people_id=&target_id=x&action_id=&rn=1&pn=1`
  )
};



// WEBPACK FOOTER //
// ./src/service/getData.js